<template>
  <div v-if="childLocationExists"
       class="status">
    <div v-if="showTitle"
         class="title">
      <icon-map-marker class="marker-icon"
                       width="8"
                       heignt="9"
                       iconColor="#B9B9B9" />
      {{ $t("locationStatus.deviceLocation") }}
    </div>

    <div v-if="locationFromHistory" class="content">
      <div class="location-datetime">
        {{  locationHistoryTrackDate | localDateTime }}
      </div>
    </div>

    <div v-else class="content">
      <div class="location-condition">
        {{ status }}
      </div>

      <div v-if="status === 'Since'" class="location-datetime">
        {{  locationTrackDate | localDateTime }}
      </div>

      <div v-else class="location-datetime">
        {{  primaryDevice.last_seen | localDateTime }}
      </div>
    </div>
  </div>

  <div class="no-locations" v-else>
    <icon-map-marker class="marker-icon"
                     width="8"
                     heignt="9"
                     iconColor="#B9B9B9" />

    <div class="text">
      {{ $t("noLocationsYet") }}
    </div>
  </div>
</template>

<script>
  import i18n from '@/services/i18n'
  import { dateDiffFromNow } from '@/services/intl'

  export default {
    props: {
      child: {
        type: Object,
        required: true
      },

      showTitle: {
        type: Boolean,
        required: false,
        default: false
      },

      position: {
        type: String,
        required: false,
        default: 'center'
      }
    },

    computed: {
      locationFromHistory() {
        return _.has(this.child.latest_location, 'from_history')
          && this.child.latest_location.from_history
      },

      locationTrackDate() {
        return this.child.latest_location.track_date
      },

      locationHistoryTrackDate() {
        if (
          _.has(this.child.latest_location, 'end_time') &&
          this.child.latest_location.end_time
        ) {
          return this.child.latest_location.end_time
        }

        return this.child.latest_location.track_date
      },

      childLocationExists() {
        return _.has(this.child, 'latest_location') && this.primaryDevice
      },

      status() {
        if (!this.child.status || !this.child.status.last_seen) {
          return i18n.t("locationStatus.lastSeen")
        }

        const lastOnlineMinutesAgo = dateDiffFromNow(this.child.status.last_seen, 'minute')

        if (lastOnlineMinutesAgo >= 60) {
          return i18n.t("locationStatus.lastSeen")
        }

        return i18n.t("locationStatus.since")
      },

      primaryDevice() {
        return this.child.devices.find(device => device.id === this.child.primary_device_id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .status {
    height: 100%;
    color: #B9B9B9;

    display: flex;
    flex-direction: column;

    font-size: 15px;

    .title {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .content {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .location-condition {
        margin-right: 5px;
      }
    }
  }

  .no-locations {
    width: 200px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    color: #B9B9B9;
  }

  .marker-icon {
    position: relative;
    margin-right: 2px;
    bottom: 2px;
  }
</style>